import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Navbar from "./components/navbar.js";
import Loading from "./components/loading";
import ErrorBoundary from "./components/errorBoundary";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import "./i18n";

if (process.env.NODE_ENV === "production") disableReactDevTools();

const AdminPage = lazy(() => import("./pages/adminPage"));
const TrailerPage = lazy(() => import("./pages/trailerPage"));
const LoginPage = lazy(() => import("./pages/loginPage"));
const ContactsPage = lazy(() => import("./pages/contactsPage"));
const UserList = lazy(() => import("./components/userList"));
const Logout = lazy(() => import("./components/logout"));
const NotFoundPage = lazy(() => import("./pages/notFoundPage"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // StrictMode intentionally invokes components and their effects twice in development to catch bugs
  <React.StrictMode>
    <Router>
      <ErrorBoundary>
        <Suspense fallback={<Loading />}>
          <Routes>
         {/*
          <Route path="/" element={<TrailerPage />} />
          <Route path="/home" element={<TrailerPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/kontaktai" element={<ContactsPage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="*" element={<NotFoundPage />} />
        */}
            <Route path="/" element={<Layout />}>
              <Route index element={<TrailerPage />} />
              <Route path="home" element={<TrailerPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="admin" element={<AdminPage />} />
              <Route path="contacts" element={<ContactsPage />} />
              <Route path="kontaktai" element={<ContactsPage />} />
              <Route path="logout" element={<Logout />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Router>
  </React.StrictMode>
);
